import React from 'react';
import { render } from 'react-dom'
import { Router, Route, browserHistory } from 'react-router'
import URLSearchParams from 'url-search-params';

import Home from './pages/Home';
import Faq from './pages/Faq';
import BuildingManagers from './pages/BuildingManagers';
import NoMatch from './pages/NoMatch';
import Tos from './pages/Tos';
import DownloadApp from './pages/DownloadApp';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-85665596-1');

import './assets/airbnb-o2/o2.css';
import './assets/airbnb-o2/o2-fonts.css';
import './assets/stylesheets/site.css';
import './assets/stylesheets/Nav.css';

function logPageView() {
  const urlParams = new URLSearchParams(window.location.search);
  let fields = {
    page: window.location.pathname,
  };

  if (urlParams.get('ref')) {
    fields['ref'] = urlParams.get('ref');
  }

  ReactGA.send(fields);
  ReactGA.pageview(window.location + "");
  window.scrollTo(0, 0)
}

render((
  <Router onUpdate={logPageView} history={browserHistory}>
    <Route path="/" component={Home} />
    <Route path="faq" component={Faq} />
    <Route path="building-managers" component={BuildingManagers} />
    <Route path="tos" component={Tos} />
    <Route path="get-the-app" component={DownloadApp} />
    <Route path="*" component={NoMatch}/>
  </Router>
), document.getElementById('root'))



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/